import React from "react";
import {useSelector} from "../../shared-services/redux-tiny";
import CartSidebar from "../cart/CartSidebar/CartSidebar";
import {PageContentWrapper, MainContent, Sidebar} from "./LayoutContentBlocks";

import currentTheme from "../../react-themes/theme";
const theme = currentTheme();

const PageContentWithCart = (props) => {
  const {
    children,
    showCart = false,
    className = "",
    style,
    mainContentClass = "",
    mainContentStyle,
    sidebarClass = "",
    sidebarStyle
  } = props;

  const {currentCart} = useSelector(state => state.cart);

  return <PageContentWrapper
    className={`transition-all-default ${className}`}
    style={{
      gap: currentCart?.line_items?.length ? theme.columns.gaps.sm : 0,
      ...style
    }}
  >
    <MainContent
      className={`
        main-content
        soft-shadow
        border-radius-md
        padding-10
        ${mainContentClass}
      `}
      style={{...mainContentStyle}}
    >
      {children}
    </MainContent>

    {showCart && (
      <Sidebar
        className={`
          overflow-x-hidden
          transition-all-default
          ${sidebarClass}
        `}
        style={{
          flexBasis: currentCart?.line_items?.length
            ? theme.cartSidebar.defaultWidth.value
            : 0,
          ...sidebarStyle
        }}
      >
        <CartSidebar
          fixed={true}
          showCart={showCart}
          className={`
            transition-all-default
          `}
        />
      </Sidebar>
    )}
  </PageContentWrapper>;
};

export default PageContentWithCart;
